import React from "react";
import SkeletonPayment from "../SkeletonPayment";

const PaymentMethodSkeleton: React.FC = () => {
  return (
    <>
      <div className="relative pt-10 pb-14 px-14 max-xl:py-10 max-xl:px-6 max-md:p-0">
        <div className="flex items-center justify-between mb-6 text-[#89D9EE] max-md:mb-4 md:pr-6">
          <h2 className="text-primary text-2xl max-sm:text-xl">
            Payment Methods
          </h2>
          <div className="skeleton w-1/4 min-h-6 !rounded-md"></div>
        </div>
        <SkeletonPayment />
      </div>
    </>
  );
};

export default PaymentMethodSkeleton;
